import React from 'react';
import { Card } from 'reactstrap';

import styles from './styles.module.scss';

export function Retirement() {
  return (
    <main id="main">
      <Card className={`${styles.cardBackground} shadow-sm p-3`}>
        <h1>Precertification Portal</h1>
        <br />
        <h2>Notice: VA Precertification Portal (VAPP) Retirement</h2>
        <p className="pt-3">
          Effective immediately precertification through the VA Precertification
          Portal (VAPP) is no longer required. The portal will be taken offline
          on <strong>9/8/2026 at 10 p.m. EDT</strong>.
          <br />
          <br />
          This change will not impact claims processing or payment. Community
          Care Network (CCN) providers should continue to provide care to
          Veterans in accordance with the existing VA authorization/Standardized
          Episode of Care (SEOC).
          <br />
          <br />
          No further action is required at this time. Questions may be directed
          to the TPA.
        </p>
      </Card>
    </main>
  );
}
